@if (store.asArray(); as topics) {
  @if (topics.length > 0) {
    <p-table
      #topicTable
      [globalFilterFields]="['title']"
      [loading]="loading"
      [value]="topics">
      <ng-template pTemplate="caption">
        <app-table-list-caption
          [searchWord]="searchWord"
          (clearTable)="clear(topicTable)"
          [quickLink]="
            activeUserStore.canAccessConfig()
              ? [
                  '/data-backend',
                  {
                    outlets: {
                      overlay: [
                        'konfiguration',
                        { outlets: { panel: 'startseite' } },
                      ],
                    },
                  },
                ]
              : null
          "
          quickLinkLabel="Startseite"
          (search)="
            topicTable.filterGlobal($event, 'contains')
          "></app-table-list-caption>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="w-1rem">Status</th>
          <th>Thema</th>
          <th>Aktionen</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-topic>
        <tr>
          <td>
            <i
              [class]="
                'fas fa-' + (topic.published ? 'earth-europe' : 'lock')
              "></i>
          </td>
          <td>
            <span class="flex align-items-center gap-3"
              ><i [class]="'w-1rem text-center fas fa-' + topic.icon"></i>
              {{ topic.title }}</span
            >
          </td>
          <td>
            <app-table-list-actions
              [item]="topic"
              (confirm)="confirm($event, topic, topic.title)">
            </app-table-list-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <app-alert header="Keine Themen gefunden" [canToggle]="false">
      Nutzen Sie Themen, um Ihren Nutzer:innen einen thematischen Einstieg in
      Ihren Atlas zu erm
      <a
        [routerLink]="[
          '/data-backend',
          {
            outlets: {
              overlay: ['themen', { outlets: { bearbeiten: 'neu' } }],
            },
          },
        ]"
        >Formular</a
      >.
    </app-alert>
  }
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-9'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
